const INITIAL_STATE = {
    data: null,
    version: 0
}

const AlertReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'alert': {

            return {
                ...state,
                data: action.payload.alert,
                version: state.version + 1
            }
        }
        default: {
            return state
        }
    }
}

export default AlertReducer